import React, { Component } from 'react';
import { linkHandler } from '../../../utils/urlUtils';
class Cta extends Component {
  render() {
    const {
      title,
      buttonText,
      ctaPosition,
      ctaMobilePosition,
      link,
      links,
      description,
      titleFontSize,
      linkTag
    } = this.props;

    return (
      <div
        className={`${link ? 'cta' : ''} text ${ctaPosition ||
          'right-center'} ${ctaMobilePosition || 'right-center-mobile'}`}
      >
        {title && (
          <div className={`text-title ${titleFontSize ? titleFontSize : ''}`}>
            {title}
          </div>
        )}
        {description && <p>{description}</p>}
        {links && links.length > 0 ? (
          <ul>
            {links.map(link => {
              return (
                <li>
                  <a
                    onClick={e => linkHandler(link.url, link.tag, e)}
                    title={link.text}
                  >
                    {link.text}
                  </a>
                </li>
              );
            })}
          </ul>
        ) : (
          <React.Fragment>
            {link && buttonText && (
              <span
                className="btn btn-outline-primary"
                onClick={e => {
                  linkHandler(link, linkTag, e);
                }}
                title={title}
              >
                {buttonText}
              </span>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default Cta;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Cta/Cta.js